(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                // 'navbar@': {
                //     templateUrl: 'app/layouts/navbar/navbar.html',
                //     controller: 'NavbarController',
                //     controllerAs: 'vm'
                // },
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar-v2.html',
                    controller: 'NavbarV2Controller',
                    controllerAs: 'vm'
                },

            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();
